// src/infra/api/Propriedade.js
import axiosInstance from '../axios';

/** Painel "Minha propriedade": sugestões do assistente e temperatura do tanque. */

/**
 * Sugestões do assistente BioAILab, por regras, já ordenadas por prioridade:
 * `[{ regra, prioridade, pagina, titulo, texto, orientacao, acao: { tipo, rotulo, pagina,
 * amostraId, planoId }, amostraId, planoId }]`.
 */
export async function sugestoesAssistente() {
    const res = await axiosInstance.get('/assistente/sugestoes');
    return res.data || [];
}

/** Último registro de temperatura do tanque; null enquanto ninguém registrou (204). */
export async function ultimaTemperatura() {
    const res = await axiosInstance.get('/registros-temperatura/ultimo');
    return res.status === 204 ? null : res.data || null;
}

/** `{ valorC, dataHora, local? }` */
export async function registrarTemperatura(dados) {
    const res = await axiosInstance.post('/registros-temperatura', dados);
    return res.data;
}
